/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';

import type { JSX } from '@ovhcloud/ods-stencil/components/spinner/custom-elements';

import { defineCustomElement as defineOsdsSpinner } from '@ovhcloud/ods-stencil/components/spinner/custom-elements/osds-spinner.js';

export const OsdsSpinner = /*@__PURE__*/createReactComponent<JSX.OsdsSpinner, HTMLOsdsSpinnerElement>('osds-spinner', undefined, undefined, defineOsdsSpinner);
